import { render, staticRenderFns } from "./PastWinnersModal.vue?vue&type=template&id=4d5f163a"
import script from "./PastWinnersModal.vue?vue&type=script&lang=js"
export * from "./PastWinnersModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports